import { render, staticRenderFns } from "./AddDocumentDialog.vue?vue&type=template&id=7e0e63ac&"
import script from "./AddDocumentDialog.js?vue&type=script&lang=js&"
export * from "./AddDocumentDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports